export function getQueryParamFromUrl(name: string): string | null {
	const result = new RegExp(`${name}=([A-z0-9-]+)`).exec(window.location.href);

	if (result) {
		return result[1];
	}

	return null;
}
